import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Fragment, useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import {
  deleteSocialHistory,
  getSocialHistoryData,
} from "../../../../services";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { SocialHistoryContext, contextType } from "../Socialhistory";
import SocialHistoryform from "./SocialHistoryform";
import SocialHistoryForm from "./SocialHistoryform";
import { useParams } from "react-router-dom";
import { getSocialHistoryType } from "../type";
import LogComonent from "../../../layouts/LogComonent";
import usePopup from "../../../../../hooks/usePopup";
import moment from "moment";
import { HL7ContexTriggerContex } from "../../../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import { Close } from "@mui/icons-material";
import EmptyListAlert from "../../../layouts/EmptyListAlert";
// import HistoryComponent from "../../../../../EMR/components/layouts/HistoryComponent";

function SocialHistoryTable() {
  const { patientId, encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const { setTrigger } = useContext(HL7ContexTriggerContex)
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(-1);
  const { tableData, setEdit, edit, setTableData, success } = useContext(
    SocialHistoryContext
  ) as contextType;
  const { mutate } = useMutation(getSocialHistoryData, {
    onSuccess: (data) => {
      setTableData(data.response);
    },
  });
  const { mutate: deletesocial, isLoading: deleteLoading } = useMutation(
    deleteSocialHistory,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
          });
          if (patientId) {
            mutate(parseInt(patientId));
          }
          setTrigger({
            encounterId: encounterId as string,
            tab: "socialhistory"
          })
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong",
          open: true,
          variant: "warning",
        });
      },
    }
  );

  const handleEdit = (data: any) => {
    setEdit({
      ...data,
    });
    setShow(false);
  };
  const handleDelete = (id: number) => {
    deletesocial({ encounterId: encounterId as string, id });
  };

  const handleClose = () => {
    setEdit(null)
  }

  useEffect(() => {
    if (patientId) {
      mutate(parseInt(patientId));
    }
  }, [success]);

  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow
              sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
            >
              {heading.map((heading, index) => (
                <TableCell
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                  align="left"
                  key={`heading${index}`}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                <EmptyListAlert alert="No social history" isData={Boolean((tableData?.length || show))} children={!show && (
                  <div className="w-full flex justify-end items-center p-2 gap-3">
                    <Button
                      color="success"
                      endIcon={<AddCircleIcon />}
                      onClick={() => {
                        setShow(true);
                        setEdit(null);
                      }}
                    >
                      add
                    </Button>
                    {/* <HistoryComponent logProps={{ title: "Social history", field: "socialhistory" }} title="Social History" tableprops={tableProps} /> */}
                    <LogComonent field="socialhistory" title="Social history" />
                  </div>
                )} />
                <Collapse in={show} timeout="auto" unmountOnExit>
                  <Box>
                    <SocialHistoryform
                      close={() => {
                        setShow(false);
                      }}
                    />
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
            {tableData?.map((item: getSocialHistoryType, index: number) => (
              <Fragment key={index}>
                <TableRow >
                  <TableCell>
                    <ListItemText
                      primary={`${item?.description?.snomedDescription}(${item?.category?.name})`}
                      secondary={
                        <>
                          <Typography
                            component="span"
                            variant="body2"
                            sx={{ color: "text.primary", display: "inline" }}
                          >
                            notes - {item?.notes}
                          </Typography>
                        </>
                      }
                    ></ListItemText>
                  </TableCell>
                  <TableCell>
                    {
                      item?.fromDate && moment(item?.fromDate).format("DD-MM-YYYY")
                    }
                    -
                    {
                      item.toDate && moment(item?.toDate).format("DD-MM-YYYY")
                    }
                  </TableCell>
                  <TableCell>{item?.status?.description}</TableCell>
                  <TableCell>
                    {edit?.id == item?.id ? <IconButton onClick={handleClose} color="error">
                      <Close />
                    </IconButton> : <IconButton
                      color="primary"
                      onClick={() => {
                        handleEdit(item);
                      }}
                    >
                      <EditIcon />
                    </IconButton>}
                    {deleteLoading && selected == index ? (
                      <CircularProgress size={18} color="error" />
                    ) : (
                      <IconButton
                        color="error"
                        onClick={() => {
                          handleDelete(item.id);
                          setSelected(index);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                    <Collapse
                      in={Boolean(edit) && edit?.id == item?.id}
                      timeout="auto"
                      unmountOnExit
                    >
                      <SocialHistoryForm
                        close={() => {
                          setEdit(null);
                        }}
                      />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default SocialHistoryTable;

const heading = ["Description", "Duration", "Status", "Options"];

// const tableProps = [
//   { heading: "CATEGORY", key: "category.name" },
//   { heading: " DESCRIPTION", key: "description.snomedDescription" },
//   { heading: "QUANTITY", key: "quantity.quantityDesc" },
//   { heading: "STATUS", key: "status.description" },
//   { heading: "FROM DATE", key: "fromDate" },
//   { heading: "TO DATE", key: "toDate" },
//   { heading: "NOTES", key: "notes" },

// ]
